export const DRAWER_HEADER_HEIGHT = 12;

export const SIZE_CONSTRAINT_EXEMPT_ROUTES = [
  'page-guide/*',
  'reference-data/:orderID/mls-map/:activeID',
  'onboarding',
  'subscribe',
  'orders',
  'order/:orderID/studies',
  'order/:orderID/paired-cost/properties',
  'order/:orderID/qc',
];
